import { render, staticRenderFns } from "./CitySub.vue?vue&type=template&id=4d27d55a&scoped=true"
import script from "./CitySub.vue?vue&type=script&lang=js"
export * from "./CitySub.vue?vue&type=script&lang=js"
import style0 from "./CitySub.vue?vue&type=style&index=0&id=4d27d55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d27d55a",
  null
  
)

export default component.exports